// src/registered/common/navigation/NavigationContext.jsx
import React, { createContext, useState, useContext, useCallback } from 'react';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [activeWorkflow, setActiveWorkflow] = useState({
    name: "Admin Dashboard",
    path: "/registered/site-admin"
  });

  // 🎯 FIX: Use useCallback to stabilize the function reference
  const setWorkflowContext = useCallback((name, path) => {
    setActiveWorkflow(prev => {
      // 🛡️ Optimization: Only update if the values actually changed
      if (prev.name === name && prev.path === path) return prev;
      return { name, path };
    });
  }, []);

  return (
    <NavigationContext.Provider value={{ activeWorkflow, setWorkflowContext }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigationContext = () => useContext(NavigationContext);